module.exports = __webpack_public_path__ + "img/Recurso 5@300x.0c94a3fa.webp";